import request from "@/utils/request";
import qs from "qs";

/**
 * 用户搜索和查询
 *
 */
export function getMemberList(params) {
  return request({
    url: "api/v3/column_hybrid/teacher_members",
    method: "get",
    params,
  });
}

/**
 * 用户学习数据
 *
 */
export function getMemberStudyData(params) {
  return request({
    url: "api/v3/column_hybrid/douyin/user_study_data",
    method: "get",
    params,
  });
}

/**
 * 用户专栏学习进度
 *
 */
export function getMemberColumnData(params) {
  return request({
    url: "api/v3/column_hybrid/douyin/user_study_columns",
    method: "get",
    params,
  });
}

/**
 * 用户学习数据列表
 *
 */
export function getMemberStudyList(params) {
  return request({
    url: "api/v3/column_hybrid/douyin/user_study_data_list",
    method: "get",
    params,
  });
}

/**
 * 用户搜索和查询
 *
 */
export function getSearchList(params) {
  return request({
    url: "/adm/user/search",
    method: "get",
    params,
  });
}

/**
 * 用户信息,  信息全面
 */
export function getUserInfo(params) {
  return request({
    url: `/adm/user/${params.id}/info`,
    method: "get",
    params,
  });
}

/**
 * 获取用户信息
 */
export function getUserDetail(params) {
  return request({
    url: `/api/v3/users/${params.id}/show`,
    method: "get",
  });
}

/**
 * 更新用户信息
 */
export function updateUserData(params) {
  return request({
    url: `/api/v3/users/update`,
    method: "post",
    params,
  });
}

/**
 * 更新用户头像
 */
export function updateUserAvatar(file) {
  let formData = new FormData();
  formData.append("avatar_file", file);
  return request.post(`/api/v3/users/update`, formData);
}

/**
 * 获取用户详细信息
 */
export function getUserDetailInfo(params) {
  return request({
    url: `/api/v3/users/${params.id}/info`,
    method: "get",
  });
}

/**
 * 获取用户的简略信息
 */
export function getUserShow(params) {
  return request({
    url: `/adm/user/${params.id}/show`,
    method: "get",
    params,
  });
}

/**
 * 获取用户的简略信息
 */
export function teacherChannelInfo(userId) {
  return request({
    url: `/adm/user/${userId}/channel`,
    method: "get",
  });
}

/**
 * 获取登录token
 */
export function getUserLoginToken(userId) {
  return request({
    url: `/adm/user/${userId}/access_token`,
    method: "get",
  });
}

/**
 * 讲师收入信息
 */
export function getUserIncomeInfo(userId) {
  return request({
    url: `/adm/user/${userId}/income/info`,
    method: "get",
  });
}

/**
 * 修改用户等级
 */
export function updateUser(params) {
  return request({
    url: `/adm/user/${params.id}/update`,
    method: "post",
    params,
  });
}

/**
 * 修改用户等级
 */
export function updateUserLevel(params) {
  const param = {
    action_name: "update_user_level",
    target_id: params.user_id,
    target_type: "User",
    remark: JSON.stringify(params),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  const userId = params.user_id;
  delete params.user_id;
  return request({
    url: `/adm/user/${userId}/update/level`,
    method: "post",
    params,
  });
}

/**
 * 修改用户机器人等级
 */
export function updateUserRobot(params) {
  return request({
    url: `/adm/user/${params.user_id}/update/robot`,
    method: "post",
    params,
  });
}

/**
 * 加入/移出首页推荐讲师列表
 */
export function saveTeacherToGlobal(userId, action) {
  return request({
    url: `/adm/user/${userId}/save_to_global`,
    method: "post",
    params: { action },
  });
}

/**
 * 根据八位ID 获取讲师的简略信息
 */
export function getUserinfoByUid(uid) {
  return request({
    url: `/adm/user/uid/${uid}/user_mini_info`,
    method: "get",
  });
}

/**
 * 讲师信息查询
 */
export function getTeacherSearchList(params) {
  return request({
    url: "/api/v3/users/sys/teachers/search",
    method: "get",
    params,
  });
}

/**
 * 跟踪的讲师列表
 */
export function selectTeacherTrackingList(params) {
  return request({
    url: "/adm/user/teacher/tracking/list",
    method: "get",
    params,
  });
}

/**
 * 讲师的跟踪信息
 */
export function teacherTracking(teacherId) {
  return request({
    url: `/adm/user/teacher/${teacherId}/tracking`,
    method: "get",
  });
}

/**
 * 讲师的合同列表
 */
export function selectTeacherContractsList(params) {
  return request({
    url: "adm/contract/list",
    method: "get",
    params,
  });
}

/**
 * 保存讲师的合同信息
 */
export function saveTeacherContract(data) {
  return request({
    url: "adm/contract/save",
    method: "post",
    data: qs.stringify(data),
  });
}

/**
 * 删除讲师的合同信息
 */
export function deleteTeacherContract(id) {
  return request({
    url: `adm/contract/${id}/delete`,
    method: "post",
  });
}
/**
 * 合同文件上传
 */
export function uploadTeacherContract(teacherId, data) {
  return request({
    url: `adm/contract/${teacherId}/upload`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data,
  });
}

/**
 * 讲师每日收入的统计
 */
export function teacherDailyIncomes(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/daily/incomes`,
    method: "get",
    params,
  });
}
/**
 * 讲师收入记录查询
 */
export function teacherDailyIncomesList(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/daily/incomes/list`,
    method: "get",
    params,
  });
}
/**
 * 讲师收入记录查询
 */
export function teacherDailyIncomesList2(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/daily/incomes/list2`,
    method: "get",
    params,
  });
}
/**
 * 查询讲师收入的购买者
 */
export function teacherIncomesBuyers(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/buyers`,
    method: "get",
    params,
  });
}

/**
 * 讲师专栏会员的购买者复购查询
 */
export function teacherColumnBuyers(columnId, params) {
  return request({
    url: `/adm/column/${columnId}/members/consumption`,
    method: "get",
    params,
  });
}

/**
 * 查询讲师收入的购买者
 */
export function teacherBuyerRecordList(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/buyer/records`,
    method: "get",
    params,
  });
}

/**
 * 删除讲师追踪
 */
export function deleteTrackTeacher(teacherId) {
  return request({
    url: `/adm/user/teacher/${teacherId}/tracking/delete`,
    method: "post",
  });
}

/**
 *  添加追踪的讲师
 */
export function addTeacherTracking(params) {
  return request({
    url: `/adm/user/teacher/${params.teacherId}/tracking/add`,
    method: "post",
    data: qs.stringify({ status: params.status, tracklog: params.tracklog }),
  });
}

/**
 * 跟踪认领
 */
export function claimTeacher(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/tracking/claim`,
    method: "post",
    params,
  });
}

/**
 * 跟踪
 */
export function trackTeacher(teacherId, params) {
  return request({
    url: `/adm/user/teacher/${teacherId}/track`,
    method: "post",
    data: qs.stringify(params),
  });
}

/**
 * 讲师认证申请列表
 */
export function selectUserProposalList(params) {
  return request({
    url: "/adm/user/proposal/list",
    method: "get",
    params,
  });
}

/**
 * 讲师认证，通过
 */
export function agreeUserProposal(params) {
  const param = {
    action_name: "add_user_proposal",
    target_id: params.user_id,
    target_type: "User",
    remark: JSON.stringify(params),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  const id = params.id;
  return request({
    url: `/adm/user/proposal/${id}/agree`,
    method: "post",
    params,
  });
}

/**
 * 讲师认证，不通过
 */
export function refuseUserProposal(params) {
  const param = {
    action_name: "refuse_user_proposal",
    target_id: params.user_id,
    target_type: "User",
    remark: JSON.stringify(params),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  const id = params.id;
  delete params.user_id;
  return request({
    url: `/adm/user/proposal/${id}/refuse`,
    method: "post",
    params,
  });
}

/**
 * 讲师认证降级
 */
export function backlevelUserProposal(params) {
  return request({
    url: "/adm/user/proposal/backlevel",
    method: "post",
    params,
  });
}

/**
 * 用户的课程订阅列表
 */
export function getSubscribedActivityList(params) {
  return request({
    url: "/api/v3/activities/subscribed",
    method: "get",
    params,
  });
}

/**
 * 用户的专栏订阅
 */
export function getSubscribedColumnList(params) {
  return request({
    url: "adm/column/subscribed",
    method: "get",
    params,
  });
}

/**
 * 用户的专栏列表
 * params: { user_id, page, pageSize }
 */
export function getSelectColumnList(params) {
  return request({
    url: "/adm/column/list",
    method: "get",
    params,
  });
}

/**
 * 用户的套餐列表
 */
export function getSelectPacketList(params) {
  return request({
    url: "/api/v3/packets",
    method: "get",
    params,
  });
}

/**
 * 用户反馈列表
 */
export function getFeedbackList(params) {
  return request({
    url: "adm/feed/list?pageSize=20",
    method: "get",
    params,
  });
}

/**
 * 编辑用户反馈
 */
export function updateFeedback(id, params) {
  return request({
    url: `adm/feed/${id}/update`,
    method: "post",
    params,
  });
}

/**
 * 删除用户反馈
 */
export function deleteFeedback(id, params) {
  return request({
    url: `adm/feed/${id}/delete`,
    method: "post",
    params,
  });
}

/**
 * 编辑讲师认证
 */
export function updateTeacherTrack(params) {
  const param = {
    action_name: "edit_proposal",
    target_id: params.user_id,
    target_type: "User",
    remark: JSON.stringify(params),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  const id = params.id;
  delete params.user_id;
  return request({
    url: `adm/user/proposal/${id}/update`,
    method: "post",
    params,
  });
}

/**
 * 删除讲师认证
 */
export function deleteProposal(params) {
  const param = {
    action_name: "delete_user_proposal",
    target_id: params.user_id,
    target_type: "User",
    remark: JSON.stringify(params),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  const id = params.id;
  return request({
    url: `adm/user/proposal/${id}/delete`,
    method: "post",
  });
}

/**
 * 获取讲师认证信息
 */
export function getUserProposal(userId) {
  return request({
    url: `adm/user/${userId}/proposal/info`,
    method: "get",
  });
}

/**
 * 获取讲师认证信息
 */
export function getProposalInfo(id) {
  return request({
    url: `adm/user/proposal/${id}/info`,
    method: "get",
  });
}

/**
 * 获取讲师认证信息
 */
export function getTeacherContactship(id) {
  return request({
    url: `/adm/user/proposal/${id}/contactship`,
    method: "get",
  });
}

/**
 * 获取奖学金列表
 */
export function getMoneyList(params) {
  return request({
    url: "/api/v3/pay/iap/recharge/list",
    method: "get",
    params,
  });
}

/**
 * 手工完成奖学金订单
 */
export function complateByAdmin(id, params) {
  return request({
    url: `/api/v3/pay/iap/recharge/${id}/result_by_admin`,
    method: "post",
    params,
  });
}

/**
 * 获取讲师直播参数
 */
export function getLivingParams(userId) {
  return request({
    url: `/adm/user/${userId}/shoot_options`,
    method: "get",
  });
}

/**
 * 设置讲师直播参数
 */
export function setLivingParams(userId, data) {
  return request({
    url: `/adm/user/${userId}/update/shoot_options`,
    method: "post",
    data,
  });
}

/**
 * 获取讲师直播参数
 */
export function getUserContactList(userId) {
  return request({
    url: `/adm/user/${userId}/contactship/all`,
    method: "get",
  });
}

/**
 * 更新登录方式
 */
export function saveLoginManage(data) {
  return request({
    url: "/adm/user/account/update",
    method: "post",
    data: qs.stringify(data),
  });
}

/**
 * 移除某种登陆方式
 */
export function removeLoginType(data) {
  return request({
    url: "/adm/user/account/revert",
    method: "post",
    data: qs.stringify(data),
  });
}

/**
 * @param {number} pingId
 */
export function getIncomeDetail(pingId) {
  return request({
    url: "/adm/user/trade/records/detail",
    method: "get",
    params: { pingId },
  });
}

export function updateUserScale(userId, data) {
  const param = {
    action_name: "update_user_scale",
    target_id: userId,
    target_type: "User",
    remark: JSON.stringify(data),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  return request({
    url: `adm/user/${userId}/update/scale`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function updateOldMemberScale(userId, data) {
  const param = {
    action_name: "update_old_member_fee",
    target_id: userId,
    target_type: "User",
    remark: JSON.stringify(data),
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  return request({
    url: `adm/user/${userId}/update/old_member_fee`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function addTeacherFeeScale(userId) {
  const param = {
    action_name: "add_teacher_fee_scale",
    target_id: userId,
    target_type: "User",
    remark: "",
  };
  request({
    url: `/adm/user/sys/operate/log`,
    method: "post",
    data: param,
  });
  return request({
    url: `adm/user/${userId}/create_scale`,
    method: "post",
  });
}

// 用户分成比例
export function getUserScale(uid, params) {
  return request({
    url: `adm/user/${uid}/fee_scale`,
    method: "get",
    params,
  });
}

// 配置了费用比例的讲师列表
export function getFeeScaleTeacherList(params) {
  return request({
    url: "adm/user/fee_scale/teacher_list",
    method: "get",
    params,
  });
}

// 讲师的老学员列表
export function getTeacherOldMemberList(teacherId, params) {
  return request({
    url: `adm/user/${teacherId}/old_member_list`,
    method: "get",
    params,
  });
}

// 添加到讲师的老学员列表
export function addToTeacherOldMember(teacherId, buyerId) {
  return request({
    url: `adm/user/${teacherId}/add_to_old_member`,
    method: "post",
    params: { buyer_id: buyerId },
  });
}

// 讲师的老学员列表移除成员
export function removeFromTeacherOldMember(teacherId, buyerId) {
  return request({
    url: `adm/user/${teacherId}/remove_from_old_member`,
    method: "post",
    params: { buyer_id: buyerId },
  });
}

export function addFans(userId, ids) {
  return request({
    url: `/adm/user/fans/add?shower_id=${userId}&ids=${ids}`,
    method: "post",
  });
}

// 消费记录
export function getPaid(studentId, params) {
  return request({
    url: `adm/user/student/${studentId}/buyer/records`,
    method: "get",
    params,
  });
}

// 注册用户
export function userRegister(data) {
  return request({
    url: `api/v3/account/email/register`,
    method: "post",
    data,
  });
}

// 查询关注讲师列表
export function getAttentionList(user_id, page, pageSize = 10) {
  return request({
    url: `adm/user/followships/teachers?user_id=${user_id}&page=${page}&pageSize=${pageSize}`,
    method: "get",
  });
}

// 查询讲师实名认证状态
export function getIdentityInfo(userId) {
  return request({
    url: "api/v3/user2/identity/info",
    method: "get",
    params: { user_id: userId },
  });
}

// 用于认证资料编辑回显
export function getIdentityDoc(userId) {
  return request({
    url: "api/v3/user2/identity/doc",
    method: "get",
    params: { user_id: userId },
  });
}
// 附属账号列表
export function selectSubUserList(userId) {
  return request({
    url: "api/v3/user2/sub_user/list",
    method: "get",
    params: { user_id: userId },
  });
}
// 创建附属账号
export function createSubUser(userId, subUserId, password) {
  return request({
    url: "api/v3/user2/sub_user/create",
    method: "post",
    params: { user_id: userId, sub_user_id: subUserId, password: password },
  });
}

/**
 * 解绑认证
 *  status = 0 正常解绑（旧认证信息有可能重新启用）,仅仅只是更换认证类型（灵活，个体工商，企业），比如 A企业认证换成 A灵活用工
 *  status = -1  解绑后更换认证身份，比如 A企业换成B企业
 */
export function unbindIdentity(userId, status) {
  const param = { user_id: userId };
  if (status) {
    param.status = status;
  }

  return request({
    url: "api/v3/user2/identity/unbind",
    method: "post",
    params: param,
  });
}

export function getApplyInfo(params) {
  return request({
    url: "/api/v3/users/apply_info",
    method: "get",
    params,
  });
}

export function getHybridApplyInfo(params) {
  return request({
    url: "/api/v3/teacher_hybrid/findByTeacherId",
    method: "get",
    params,
  });
}

export function getSwitch(params) {
  return request({
    url: "/api/v3/system/switch",
    method: "get",
    params,
  });
}

export function getChatMemberInfo(params) {
  return request({
    url: "/api/v3/teacher_hybrid/douyin/get_member_info",
    method: "get",
    params,
  });
}

export function saveSwitch(param) {
  return request({
    url: "/adm/server/switch/save",
    method: "post",
    params: param,
  });
}

export function applyHybridChannel(param) {
  return request({
    url: "/api/v3/teacher_hybrid/new_visitor_create",
    method: "post",
    params: param,
  });
}

/**
 * 查询协议同意记录
 * GET /api/v3/user/identity/agreement/records
 */
export function getAgreementRecords(params) {
  return request({
    url: "/api/v3/user/identity/agreement/records",
    method: "get",
    params,
  });
}

/**
 * 提交协议同意记录
 * POST /api/v3/user/identity/agreement/record
 * 使用 JSON body 传递参数
 */
export function postAgreementRecord(data) {
  return request({
    url: "/api/v3/user/identity/agreement/record",
    method: "post",
    data,
  });
}
